import { render } from "./add_disciplina_professor.vue?vue&type=template&id=4e429188"
import script from "./add_disciplina_professor.vue?vue&type=script&lang=js"
export * from "./add_disciplina_professor.vue?vue&type=script&lang=js"

import "./add_disciplina_professor.vue?vue&type=style&index=0&id=4e429188&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__